import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from 'antd';
import { useMicrophoneDevices } from '@newtontechnologies/libs-browser-mic/mic-inputs';
import { setDeviceSignal } from 'screens/DashboardScreen/pages/EditorPage/signalsStore/transcriptionSource';
import { txt } from 'libs/i18n';
import { useEffect } from 'react';
const MicrophoneSelect = ({ value, onChange }) => {
    const devices = useMicrophoneDevices();
    useEffect(() => {
        if (devices !== 'loading' && devices !== 'denied' && devices.length > 0) {
            setDeviceSignal(devices[0]);
        }
    }, [devices]);
    if (devices === 'loading') {
        return _jsx("div", { children: txt('loadingDevices') });
    }
    if (devices === 'denied') {
        return _jsx("div", { style: { color: 'var(--ant-color-error)' }, children: txt('micDenied') });
    }
    const options = devices.map((device) => ({
        value: device.deviceId,
        label: device.label || txt('unknownDevice'),
    }));
    return (_jsx(Select, { options: options, value: value, onChange: (deviceId) => {
            const selected = devices.find((dev) => dev.deviceId === deviceId);
            if (selected !== undefined) {
                onChange(selected);
            }
        } }));
};
export default MicrophoneSelect;
